<div style="position:absolute; right:0; top:0; padding:20px; z-index:1;">
	<div style="display: flex; align-items: center; justify-content: center;">
		<span *ngIf="allowCancel" (click)="cancel($event)" role="button" class="jmCloseBtn"></span>
	</div>
</div>

<div class="componentFormContainer">
	<div style="margin-bottom: 10px; margin-top: 20px;">Connect your Journeys global account</div>
	<h1 class="gTextHeadline" [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing50btm'">Please enter your global account <span class="gColorAccentPrimary">credentials</span> to complete account connection</h1>
	<label for="txtU" class="form-label">Username or Email Address</label>
	<input #txtU
		   [ngClass]="(showMinimize)?'verticalSpacing25btm':'verticalSpacing25btm'"
		   id="txtU"
		   type="text"
		   autocomplete="off"
		   autocapitalize="off"
		   class="form-control gFormInput"
		   maxlength="50"
		   placeholder="Username or Email Address"
		   [(ngModel)]="frmLogin.username"
		   (keydown)="submitLogin($event, null)"
		   (blur)="submitLogin($event, null)" />

	<label for="txtP" class="form-label">Password<span class="gColorAccentPrimary"> (Case Sensitive)</span></label>
	<div style="position: relative;">
		<input #txtP
			   id="txtP"
			   style="width: 100%;"
			   type="password"
			   autocomplete="off"
			   autocapitalize="off"
			   class="form-control gFormInput"
			   maxlength="50"
			   placeholder="Password (Case Sensitive)"
			   [(ngModel)]="frmLogin.password"
			   (keydown)="submitLogin($event, null)" />
		<i tabindex="-1" class="jmActionIcon jmPrimaryForeground inputIcon" [ngClass]="(txtPwType === 'password')?'fas fa-eye-slash':'fas fa-eye'" (click)="showPassword((txtPwType==='password')?'text':'password')"></i>
	</div>
	<div [ngClass]="(!isLogging && msg !=='')?'':'hideClickable'" class="message" [innerHTML]="msg">
	</div>

	<div class="loadingSpinnerContainer" [ngClass]="(showMinimize)?'verticalSpacing30btm':'verticalSpacing40btm'">
		<div *ngIf="!isLogging" style="width: 100%;"><button type="button" class="btn btn-lg btn-primary" (click)="submitLogin($event, true)" [disabled]="!canLogin()" style="width: 100%;">Next</button></div>
		<div *ngIf="isLogging"><span class="jmWidgetLoadingIcon20"></span></div>
	</div>

	<div style="text-align: center; margin-bottom: 10px;">
		Don't have an account? Creating one is free! Sign up <a href="javascript:void(0);" (click)="createAccount($event)">here</a>.
	</div>
</div>
